// Gray circle with a white right-pointing arrow, used for the advice-flow Exit
// control. Exported as an SVG markup string (not a .svg file URL) so it can be
// rendered inline through SVGWrapper / svg-inline-react like the sibling icons.
//
// The source export from design carried a ~68px x-offset (its artwork lived off
// to the right of a 0 0 30 30 viewBox), so the transform's x-translation is
// dropped from 95.5 to 27.5 to recenter the circle at (15,15) within the box.
const iconExit = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd" transform="matrix(0 -1 -1 0 27.5 27.5)">
      <circle fill="#7A8E96" cx="12.5" cy="12.5" r="12.5"/>
      <path
        fill="#FFF"
        d="m13.383 4.323 4.784 4.679a1.09 1.09 0 0 1 0 1.56 1.14 1.14 0 0 1-1.595 0l-2.947-2.884v13.195a1.127 1.127 0 0 1-2.255 0V7.677L8.423 10.56a1.14 1.14 0 0 1-1.595 0 1.09 1.09 0 0 1 0-1.56l4.784-4.678c.244-.24.57-.347.886-.322.316-.025.641.083.885.322z"
      />
    </g>
  </svg>
`

export default iconExit
